export default __webpack_public_path__ + "static/media/showcase-record.eb9a8772.jpg";